import capitalize from './capitalize';

// eslint-disable-next-line no-restricted-globals
export default function formatStatus(status?: Status): string | null {
  if (status === undefined) return 'unbekannt';
  if (status === 'sensor_defekt') return 'Sensorstörung';
  return capitalize(status);
}
